const scripts = [
  {
    name: "pdfjsLib",
    src: "https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.min.js",
    fallback: "https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.min.js"
  },
  {
    name: "PDFLib",
    src: "https://unpkg.com/pdf-lib@1.4.0/dist/pdf-lib.min.js",
    fallback: "https://cdn.jsdelivr.net/npm/pdf-lib@1.4.0/dist/pdf-lib.min.js",
  },
  {
    name: "download",
    src: "https://unpkg.com/downloadjs@1.4.7",
    fallback: "https://cdn.jsdelivr.net/npm/downloadjs@1.4.7/download.min.js",
  },
  { name: "makeTextPDF", src: "/makeTextPDF.js" },
];

const assets = {};
export function getAsset(name) {
  if (assets[name]) return assets[name];
  const script = scripts.find((s) => s.name === name);
  if (!script) throw new Error(`Script ${name} not exists.`);
  return prepareAsset(script);
}

export function prepareAsset({ name, src, fallback }) {
  if (assets[name]) return assets[name];
  assets[name] = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    
    // Add timeout for script loading
    const timeout = setTimeout(() => {
      reject(`The script ${name} took too long to load.`);
      console.error(`Timeout loading script: ${name}`);
    }, 30000); // 30 second timeout
    
    script.onload = () => {
      clearTimeout(timeout);
      // Configure PDF.js to disable Web Workers to avoid DataCloneError
      if (name === 'pdfjsLib' && window.pdfjsLib) {
        try {
          // Disable workers completely
          window.pdfjsLib.GlobalWorkerOptions.workerSrc = false;
          window.pdfjsLib.GlobalWorkerOptions.workerPort = null;
          
          // Add standard font data URL to prevent font warnings
          window.pdfjsLib.GlobalWorkerOptions.standardFontDataUrl = 'https://unpkg.com/pdfjs-dist@3.11.174/standard_fonts/';
          
          console.log('PDF.js Web Workers disabled to prevent DataCloneError');
        } catch (configError) {
          console.warn('Could not configure PDF.js worker options:', configError);
        }
      }
      resolve(window[name]);
      console.log(`${name} is loaded.`);
    };
    
    script.onerror = (error) => {
      clearTimeout(timeout);
      console.error(`Failed to load script ${name} from primary source:`, error);
      
      // Try fallback if available
      if (fallback) {
        console.log(`Trying fallback for ${name}...`);
        script.src = fallback;
        script.onerror = (fallbackError) => {
          console.error(`Failed to load script ${name} from fallback:`, fallbackError);
          reject(`The script ${name} didn't load correctly from any source.`);
          alert(
            `Some scripts did not load correctly. Please reload and try again.`
          );
        };
        return;
      }
      
      reject(`The script ${name} didn't load correctly.`);
      alert(
        `Some scripts did not load correctly. Please reload and try again.`
      );
    };
    
    document.body.appendChild(script);
  });
  return assets[name];
}

export default function prepareAssets() {
  scripts.forEach(prepareAsset);
}

// out of the box fonts
const fonts = {
  Courier: {
    correction(size, lineHeight) {
      return (size * lineHeight - size) / 2 + size / 6;
    },
  },
  Helvetica: {
    correction(size, lineHeight) {
      return (size * lineHeight - size) / 2 + size / 10;
    },
  },
  "Times-Roman": {
    correction(size, lineHeight) {
      return (size * lineHeight - size) / 2 + size / 7;
    },
  },
};
// Available fonts
export const Fonts = {
  ...fonts,
  標楷體: {
    src: "/CK.ttf", // 9.9 MB
    correction(size, lineHeight) {
      return (size * lineHeight - size) / 2;
    },
  },
};

export function fetchFont(name) {
  if (fonts[name]) return fonts[name];
  const font = Fonts[name];
  if (!font) throw new Error(`Font '${name}' not exists.`);
  fonts[name] = fetch(font.src)
    .then((r) => r.arrayBuffer())
    .then((fontBuffer) => {
      const fontFace = new FontFace(name, fontBuffer);
      fontFace.display = "swap";
      fontFace.load().then(() => document.fonts.add(fontFace));
      return {
        ...font,
        buffer: fontBuffer,
      };
    });
  return fonts[name];
}
